import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-backup-pro-upgrade',
  template: `
    <img [src]="cloudImgUrl()" />
    <div class="title">
      {{ 'PAGES.BACKUPS.PRO_UPGRADE_MESSAGE.TITLE' | translate }}
    </div>
    <div class="subtitle">
      {{ 'PAGES.BACKUPS.PRO_UPGRADE_MESSAGE.SUBTITLE' | translate }}
    </div>
    <button type="button" mat-button color="accent" (click)="upgradeButtonClicked.emit()">
      {{ 'PAGES.BACKUPS.PRO_UPGRADE_MESSAGE.UPGRADE_BUTTON_TEXT' | translate }}
    </button>
  `,
  styles: [
    `
      .subtitle {
        color: gray;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BackupProUpgradeComponent {
  @Output() upgradeButtonClicked: EventEmitter<void> = new EventEmitter();

  cloudImgUrl(): string {
    return `https://vstatic-prod.apigateway.co/wsp-portal-client.9223372035065798524.demo/assets/images/cloud.svg`;
  }
}
